<script setup lang="ts">
import { getTcpaLanguageHtml, getTcpaLanguagePlain } from '@/config/tcpa'
import { useFormStore } from '@/stores/form'

defineProps<{
  isVisible: boolean
}>()

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'close'): void
}>()

const formStore = useFormStore()

const tcpaHtml = getTcpaLanguageHtml()
const tcpaPlain = getTcpaLanguagePlain()

function handleConfirm() {
  // Store TCPA language for lead post
  formStore.setField('tcpaLanguage', tcpaPlain)
  emit('confirm')
}
</script>

<template>
  <!-- Backdrop -->
  <Transition name="fade">
    <div
      v-if="isVisible"
      class="fixed inset-0 bg-black/30 z-40"
      @click="emit('close')"
    />
  </Transition>

  <!-- Drawer -->
  <Transition name="slide-up">
    <div
      v-if="isVisible"
      class="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl z-50 safe-area-bottom"
    >
      <!-- Content -->
      <div class="px-4 py-4 max-h-[50vh] overflow-hidden flex flex-col">
        <!-- Scrollable TCPA text -->
        <div class="flex-1 overflow-y-auto text-xs text-gray-500 leading-relaxed mb-3">
          <p v-html="tcpaHtml" />
        </div>

        <!-- Confirm button -->
        <button
          @click="handleConfirm"
          class="w-full py-3.5 bg-primary text-white rounded-full font-semibold text-base shadow-lg shadow-primary/30 active:scale-[0.98] transition-all"
        >
          SEE RESULTS
          <svg class="inline w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.safe-area-bottom {
  padding-bottom: max(1.5rem, env(safe-area-inset-bottom));
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease-out;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
